import React from "react";
import { classNames } from "../../../utils/classNames";

/**
 * A small round tag on the corner of a thing on the bench's rail — the
 * pulled drawing — for taking that thing off where it hangs. It sits
 * half over the corner, on the object, because it is part of the
 * fiction: the drawing goes back on the pile. (A tool comes off its
 * hook by hand instead, dragged down into a tray.) That is also why its
 * glyph is never the ✕ — the ✕
 * is the computer's and floats off a paper to put it away (CloseButton);
 * a tag on the paper does something to it.
 */
export const CornerTag: React.FC<{
  label: string;
  title?: string;
  disabled?: boolean;
  onClick: () => void;
  className?: string;
  testId?: string;
  sfx?: string;
  children: React.ReactNode;
}> = ({
  label,
  title,
  disabled,
  onClick,
  className,
  testId,
  sfx,
  children,
}) => (
  <button
    type="button"
    data-testid={testId}
    data-sfx={sfx}
    disabled={disabled}
    onClick={(event) => {
      event.stopPropagation();
      onClick();
    }}
    aria-label={label}
    title={title ?? label}
    className={classNames(
      "absolute -right-0.5 -top-0.5 size-4 items-center justify-center rounded-full border border-black/50 bg-paper-manila text-[0.6rem] leading-none text-ink-black shadow hover:brightness-105 disabled:cursor-not-allowed disabled:opacity-40",
      className ?? "flex",
    )}
  >
    {children}
  </button>
);
